import React, { useState } from 'react';

const Contact = () => {
	const [formData, setFormData] = useState({ name: '', email: '', message: '' });
	const [status, setStatus] = useState('');

	// 🚨 HIER MUSST DU DEINE PERSÖNLICHE FORMSPREE-URL EINFÜGEN
	const formspreeUrl = "https://formspree.io/f/mwpqwodw";

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevData) => ({ ...prevData, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setStatus('Wird gesendet...');
		try {
			const response = await fetch(formspreeUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json',
				},
				body: JSON.stringify(formData),
			});
			if (response.ok) {
				setStatus('Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet.');
				setFormData({ name: '', email: '', message: '' });
			} else {
				setStatus('Fehler beim Senden. Bitte versuchen Sie es später erneut.');
			}
		} catch (error) {
			console.error('Sende-Fehler:', error);
			setStatus('Fehler beim Senden. Bitte versuchen Sie es später erneut.');
		}
	};

	return (
		<section id="kontakt" className="section">
			<div className="container">
				<h2 className="section-title">Interessiert? <span>Lassen Sie uns reden.</span></h2>
				<p className="section-subtitle">Beschreiben Sie kurz Ihr Projekt oder Ihre Idee und ich melde mich bei Ihnen für ein unverbindliches Erstgespräch und ein individuelles Angebot.</p>
				<form className="contact-form" onSubmit={handleSubmit}>
					<input type="text" name="name" placeholder="Ihr Name" value={formData.name} onChange={handleChange} required />
					<input type="email" name="email" placeholder="Ihre E-Mail" value={formData.email} onChange={handleChange} required />
					<textarea name="message" rows="6" placeholder="Erzählen Sie mir von Ihrem Projekt..." value={formData.message} onChange={handleChange} required></textarea>
					<button type="submit" className="cta-button">Anfrage senden</button>
				</form>
				{status && <p style={{ textAlign: 'center', marginTop: '1.5rem', fontWeight: 'bold' }}>{status}</p>}
			</div>
		</section>
	);
};

export default Contact;